import { useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import Loading from "~/components/Loading";
import { ManifoldNextGenSideNav } from "~/components/ManifoldNextGenSideNav";
import { useManifoldNextGenFeature } from "~/hooks/useManifoldNextGenFeature";
import { useUserPreferences } from "~/hooks/useUserPreferences";
import { cn } from "~/lib/utils";
import { ROUTE_404 } from "~/router/constants";

export function ManifoldNextGenLayout() {
  const feature = useManifoldNextGenFeature();
  const [preferences, updatePreferences] = useUserPreferences();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  if (feature.isLoading) {
    return <Loading />;
  }

  if (!feature.enabled || !preferences.optedIntoManifoldNextGen) {
    return <Navigate to={ROUTE_404} replace />;
  }

  const handleSwitchToClassic = () => {
    updatePreferences({ optedIntoManifoldNextGen: false });
    navigate("/");
  };

  return (
    <div data-theme="manifold-nextgen" className="flex h-screen bg-background text-foreground">
      <ManifoldNextGenSideNav collapsed={collapsed} onCollapsedChange={setCollapsed} />

      <main className="flex min-w-0 flex-1 flex-col overflow-auto">
        <div className="flex items-center border-b border-border px-3 py-2">
          <button
            type="button"
            onClick={handleSwitchToClassic}
            className={cn(
              "ml-auto cursor-pointer rounded-md border border-foreground/20 px-3 py-1.5",
              "text-sm font-medium text-foreground",
              "transition-colors hover:bg-accent hover:border-foreground/30",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
            )}
          >
            Switch to classic
          </button>
        </div>
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
